'use client';

import { useContext } from 'react';

import { StoreContext } from '../Store';

import Card from '@/components/Card';
import ProductCardSkeleton from '../Loader/ProductCardSkeleton';

import { useLocalizedProperty } from '@/hooks/useLocalizedProperty';
import type { IProduct } from '@/interfaces/products.interface';

const MarqueeSlider = () => {
  const context = useContext(StoreContext);
  const [homeProducts] = context.homeProductState;
  const getLocalizedProperty = useLocalizedProperty();
  const isLoading = !homeProducts || homeProducts.length === 0;

  return isLoading ? (
    <ProductCardSkeleton count={4} />
  ) : (
    <div className="grid grid-cols-2 gap-2 overflow-hidden lg:grid-cols-4 lg:gap-4">
      {homeProducts?.map(({ _id, name, slug, variants, thumbnail }: IProduct) => (
        <Card
          key={_id}
          productName={getLocalizedProperty(name)}
          slug={slug}
          variants={variants}
          thumbnail={thumbnail}
        />
      ))}
    </div>
  );
};

export default MarqueeSlider;
